import { useState } from 'react';
import { getBrowserTimezone } from '~/lib/DateTime.js';
import useCurrentBusiness from '~/lib/useCurrentBusiness.jsx';
import { setClientTimezoneOverride } from '~/public/lib/useClientTimezone.js';
import TimezoneSelect, {
    canonicalTimezoneName,
} from '~/components/TimezoneSelect.jsx';
import { DateTime } from 'luxon';
import { FormPart, part } from '~/lib/FormCssApi';

const BookingTimeZone = ({ clientTz, className }) => {
    const [isChanging, setIsChanging] = useState(false);
    const browserTz = getBrowserTimezone();
    const business = useCurrentBusiness();
    const businessTz = business?.timezone;

    // When the business always books in its own time zone the client doesn't get a say
    const canChange = !business?.fixed_timezone;

    const changeLink = canChange && !isChanging && (
        <button
            type="button"
            className="link ml-1"
            onClick={() => setIsChanging(true)}
        >
            Change
        </button>
    );

    const select = isChanging && (
        <TimezoneSelect
            value={canonicalTimezoneName(clientTz)}
            onChange={newTz => {
                setClientTimezoneOverride(newTz);
                setIsChanging(false);
            }}
            className="mt-1"
            inputClassName="w-full text-sm"
        />
    );

    // Everything all matchy? No need to be verbose, but still allow a change
    if (clientTz === browserTz && businessTz === browserTz) {
        if (!canChange) {
            return null;
        }

        return (
            <div
                {...part(FormPart.TIMEZONE)}
                className={`text-sm text-gray-500 mb-2 text-right ${className}`}
            >
                {!isChanging && (
                    <button
                        type="button"
                        className="link"
                        onClick={() => setIsChanging(true)}
                    >
                        Change time zone
                    </button>
                )}
                {select}
            </div>
        );
    }

    const dateTime = DateTime.local({ zone: clientTz });

    // Format the DateTime to display the human-readable time zone name
    const humanTimezone =
        dateTime.toFormat('ZZZZZ') + ' (UTC ' + dateTime.toFormat('ZZ') + ')';

    return (
        <div
            {...part(FormPart.TIMEZONE)}
            className={`text-sm text-gray-500 mb-2 text-right ${className}`}
        >
            <div title={clientTz}>
                Times shown in {humanTimezone}
                {changeLink}
            </div>
            {select}
        </div>
    );
};

export default BookingTimeZone;
